export default function Circle({ backgroundColor }) {
  return (
    <div
      style={{ backgroundColor }}
      className="w-[10px] h-[10px] rounded-full"
    />
  );
}
